import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";

export function LanguageToggle({ className = "" }) {
  const { i18n } = useTranslation();
  const lang = i18n.language?.startsWith("es") ? "es" : "en";
  const set = (l) => i18n.changeLanguage(l);
  return (
    <div data-testid="language-toggle" className={`inline-flex items-center border-2 border-zinc-700 ${className}`}>
      <span className="px-2 text-zinc-500"><Languages size={14} /></span>
      {["en", "es"].map((l) => (
        <button
          key={l}
          data-testid={`lang-${l}`}
          onClick={() => set(l)}
          className={`px-2.5 py-1 font-head font-bold text-xs uppercase tracking-wide transition-colors ${
            lang === l ? "bg-[#FF5722] text-black" : "text-zinc-400 hover:text-white"
          }`}
        >
          {l === "en" ? "EN" : "ES"}
        </button>
      ))}
    </div>
  );
}
